import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdatePostMutation } from "../graphql/mutations";
import type {
  UpdatePostMutationType,
  UpdatePostMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdatePostMutation = (
  options?: MutationHookOptions<
    UpdatePostMutationType,
    UpdatePostMutationVariablesType
  >
) => {
  return useMutation<UpdatePostMutationType, UpdatePostMutationVariablesType>(
    UpdatePostMutation,
    options
  );
};
